import Column from '@components/Column';
import { OrderLogResponse } from '@models/order/orderLog';

import OrderItem from './OrderItem';
import styles from './styles.module.scss';

interface Props {
    orderLog: OrderLogResponse;
}

function OrderItems({ orderLog }:Props) {
    const { orderItems } = orderLog;
    return <Column fullWidth as='section'
        className={styles.container}>
        {orderItems.map((orderItem) => (
            <OrderItem orderItem={orderItem}
                key={orderItem.itemId} />
        ))}
    </Column>;
}

export default OrderItems;
